import { Component, inject } from '@angular/core';
import { CognitoService } from 'app/core/http/services/cognito.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from 'app/services/dialog.service';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss'],
})
export class RecuperarSenhaComponent {
  public form!: FormGroup;
  public loading = false;
  public submittedCode = false;
  public successSubmited = false;
  private snackBar: MatSnackBar = inject(MatSnackBar);

  constructor(private cognitoService: CognitoService, private fb: FormBuilder, private router: Router, private dialog: DialogService) {}

  ngOnInit() {
    this.form = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  private getFriendlyErrorMessage(error: any): string {
    if (!error) return 'Ocorreu um erro desconhecido ao enviar o código de recuperação.';

    if (error.name) {
      switch (error.name) {
        case 'UserNotFoundException':
          return 'Nenhuma conta encontrada com este e-mail. Verifique o endereço digitado.';
        case 'InvalidParameterException':
          return 'O e-mail fornecido é inválido. Por favor, corrija e tente novamente.';
        case 'TooManyRequestsException':
          return 'Muitas tentativas em um curto período. Por favor, aguarde e tente novamente mais tarde.';
        case 'LimitExceededException':
          return 'Limite de tentativas excedido. Sua conta foi temporariamente bloqueada por segurança.';
        case 'NotAuthorizedException':
          return 'Esta conta ainda não foi confirmada. Por favor, verifique seu e-mail para confirmar sua conta.';
      }
    }

    if (error.message && error.message.includes('Network Error')) {
      return 'Não foi possível conectar ao servidor. Verifique sua conexão com a internet.';
    }

    return error.message || 'Ocorreu um erro ao enviar o código de recuperação. Por favor, tente novamente.';
  }

  openSnackBar(message: string, status: 'success' | 'error' | 'warning') {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: status === 'success' ? 'snack-success' : status === 'error' ? 'snack-error' : 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }

  goToUrl(page: string) {
    this.router.navigate([page]);
  }

  async sendCodeToEmail() {
    if (this.form.invalid) {
      this.openSnackBar('Por favor, insira um e-mail válido.', 'error');
      return;
    }

    this.loading = true;
    this.submittedCode = false;
    this.successSubmited = false;

    try {
      await this.cognitoService.sendPasswordResetCode(this.form.value.email);

      this.submittedCode = true;
      this.successSubmited = true;
      this.openSnackBar('Código de recuperação enviado com sucesso! Verifique seu e-mail.', 'success');

      setTimeout(() => {
        this.openComponentDialogNewPasswordForm();
      }, 500);
    } catch (error) {
      console.error('Erro ao enviar código:', error);
      this.submittedCode = true;
      this.successSubmited = false;
      this.openSnackBar(this.getFriendlyErrorMessage(error), 'error');
    } finally {
      this.loading = false;
    }
  }

  openComponentDialogNewPasswordForm() {
    this.dialog.openNovaSenhaDialog({
      title: `Redefinir senha`,
      param: {
        submittedCode: this.submittedCode,
        successSubmited: this.successSubmited,
        email: this.form.value.email,
      },
    });
  }
}
